/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamRequestHubReturnMutationVariables = Types.Exact<{
  input: Types.FccHubReturnRequestInput
}>

export type AdVehicleStreamRequestHubReturnMutation = {
  __typename?: 'Mutation'
  fccRequestHubReturn: any | null
}

export const AdVehicleStreamRequestHubReturnDocument = gql`
    mutation AdVehicleStreamRequestHubReturn($input: FccHubReturnRequestInput!) {
  fccRequestHubReturn(input: $input)
}
    `
export type AdVehicleStreamRequestHubReturnMutationFn = Apollo.MutationFunction<
  AdVehicleStreamRequestHubReturnMutation,
  AdVehicleStreamRequestHubReturnMutationVariables
>

/**
 * __useAdVehicleStreamRequestHubReturnMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamRequestHubReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamRequestHubReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamRequestHubReturnMutation, { data, loading, error }] = useAdVehicleStreamRequestHubReturnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdVehicleStreamRequestHubReturnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamRequestHubReturnMutation,
    AdVehicleStreamRequestHubReturnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamRequestHubReturnMutation,
    AdVehicleStreamRequestHubReturnMutationVariables
  >(AdVehicleStreamRequestHubReturnDocument, options)
}
export type AdVehicleStreamRequestHubReturnMutationHookResult = ReturnType<
  typeof useAdVehicleStreamRequestHubReturnMutation
>
export type AdVehicleStreamRequestHubReturnMutationResult =
  Apollo.MutationResult<AdVehicleStreamRequestHubReturnMutation>
export type AdVehicleStreamRequestHubReturnMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamRequestHubReturnMutation,
    AdVehicleStreamRequestHubReturnMutationVariables
  >
